import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { DealComponent } from './deal.component';
import { DealRoutingModule } from './deal.routing.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { DealsDetailsComponent } from './deals-details/deals-details.component';
import { ClipboardModule } from 'ngx-clipboard';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { LayoutModule } from 'src/app/layout/layout.module';

@NgModule({
  declarations: [
    DealComponent,
    DealsDetailsComponent,
  ],
  imports: [
    CommonModule,
    DealRoutingModule,
    SharedModule,
    FormsModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    ClipboardModule,
    CarouselModule,
    MatExpansionModule,
    MatIconModule,
    LayoutModule 
  ],
  exports: [DealComponent] 
})
export class DealModule { }
